export const Sizing = {
	unit: "cm",
	maxWidth: 28,
	maxHeight: 40,
	// productStorageExp: 60 * 60 * 24 * 7 * 1000 /* 1 week */,
	productStorageExp: 60 * 60 * 24 * 1000 /* 24hrs */,
};
